class TribuSpotted extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.openButtons = [...this.querySelectorAll('[data-spotted-open]')];
    this.slides = [...this.querySelectorAll('[data-spotted-slide]')];
    this.lightbox = this.querySelector('[data-spotted-lightbox]');

    this.openButtons.forEach((button, index) => {
      button.addEventListener('click', () => this.open(index));
    });

    // Use event delegation for all dynamic lightbox controls (close, prev, next buttons)
    this.lightbox.addEventListener('click', (event) => {
      const target = event.target;
      if (target.closest('[data-spotted-close]')) {
        this.close();
      } else if (target.closest('[data-spotted-prev]')) {
        this.navigate(-1);
      } else if (target.closest('[data-spotted-next]')) {
        this.navigate(1);
      } else if (target === this.lightbox) {
        this.close();
      }
    });

    document.addEventListener('keyup', (event) => {
      if (this.lightbox.hasAttribute('hidden')) return;
      if (event.code.toUpperCase() === 'ESCAPE') this.close();
      if (event.key === 'ArrowLeft') this.navigate(-1);
      if (event.key === 'ArrowRight') this.navigate(1);
    });
    
    /* Temporarily show the lightbox */
    // this.open(0);
  }

  open(index) {
    this.currentIndex = index;
    this.update();
    this.lightbox.removeAttribute('hidden');
    this.lightbox.classList.remove('tw:hidden');
    this.lightbox.classList.add('tw:grid', 'tw:place-items-center');
    document.body.classList.add('overflow-hidden');
    const activeCloseButton = this.slides[this.currentIndex].querySelector('[data-spotted-close]');
    if (typeof trapFocus === 'function') trapFocus(this.lightbox, activeCloseButton);
  }

  close(focusThumb = true) {
    this.lightbox.setAttribute('hidden', '');
    this.lightbox.classList.add('tw:hidden');
    this.lightbox.classList.remove('tw:grid', 'tw:place-items-center');
    document.body.classList.remove('overflow-hidden');
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(focusThumb ? this.openButtons[this.currentIndex] : null);
    }
  }

  navigate(step) {
    this.currentIndex = (this.currentIndex + step + this.slides.length) % this.slides.length;
    this.update();
  }

  update() {
    this.slides.forEach((slide, index) => {
      const isCurrent = index === this.currentIndex;
      if (isCurrent) {
        slide.classList.remove('tw:hidden');
        slide.classList.add('tw:grid', 'tw:place-items-center');
      } else {
        slide.classList.add('tw:hidden');
        slide.classList.remove('tw:grid', 'tw:place-items-center');
      }
      // if (isCurrent) {
      //   const prevBtn = slide.querySelector('[data-spotted-prev]');
      //   const nextBtn = slide.querySelector('[data-spotted-next]');
      //   if (prevBtn) {
      //     prevBtn.hidden = this.currentIndex === 0;
      //     if (this.currentIndex === 0) {
      //       prevBtn.classList.add('tw:hidden');
      //       prevBtn.classList.remove('tw:grid');
      //     } else {
      //       prevBtn.classList.remove('tw:hidden');
      //       prevBtn.classList.add('tw:grid');
      //     }
      //   }
      //   if (nextBtn) {
      //     nextBtn.hidden = this.currentIndex === this.slides.length - 1;
      //     if (this.currentIndex === this.slides.length - 1) {
      //       nextBtn.classList.add('tw:hidden');
      //       nextBtn.classList.remove('tw:grid');
      //     } else {
      //       nextBtn.classList.remove('tw:hidden');
      //       nextBtn.classList.add('tw:grid');
      //     }
      //   }
      // }
    });
  }
}

if (!customElements.get('tribu-spotted')) {
  customElements.define('tribu-spotted', TribuSpotted);
}
